<!--我的页面-->
<template>
    <div class="id">
        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf" :swipeable="false">
            <van-tab v-for="(item, index) in source" :key="index" :title="item.name">
                <div v-show="index == 0">
                    <div class="overview">
                        <div style="font-size: 18px;">{{ $t('资产总估值') }}</div>
                        <div style="padding-top: 10px;font-size: 22px;">
                            ${{ totalMoney }}
                            <span style="padding-left: 10px;">{{ unit }}</span>
                        </div>
                        <div class="trend">
                            <div>{{ $t('资产走势') }}</div>
                            <div class="trendW">
                                <div v-for="(value, index) in rowList" :key="value.id" class="switchS"
                                    :class="{ 'switchB': indexS == index }" @click="timeCk(index)">
                                    {{ value.name }}
                                </div>
                            </div>
                        </div>
                        <LineChart :xData="xData" :yData="yData" v-if="yData.length > 0" />
                        <van-empty :description="$t('暂无数据')" v-else />

                        <div class="btn">
                            <div @click="$router.push('/mobile/topUp')">{{ $t('充值') }}</div>
                            <div @click="$router.push('/mobile/extract')">{{ $t('提币') }}</div>
                            <div @click="$router.push('/mobile/exchange')">{{ $t('闪兑') }}</div>
                            <div @click="goToTab(7)">{{ $t('划转') }}</div>
                        </div>
                    </div>
                    <div class="overview" style="margin-bottom: 20px;">
                        <div class="column" v-for="(item, index) in accountInfo" :key="index + 'b'">
                            <div
                                :class="{ color1: index == 0, color2: index == 1, color3: index == 2, color4: index == 3,color5: index == 4 }">
                                <span class="dot"
                                    :class="{ dot1: index == 0, dot2: index == 1, dot3: index == 2, dot4: index == 3,dot5: index == 4 }"></span>
                                {{ item.name }}
                            </div>
                            <div>
                                {{ item.percent }}%
                            </div>
                        </div>
                        <div class="titleS">{{ $t('资产分布') }}</div>
                        <LineChart1 :data="accountInfo" />
                        <div class="column" v-for="(item, index) in accountInfo" :key="index + 'c'">
                            <div
                                :class="{ color1: index == 0, color2: index == 1, color3: index == 2, color4: index == 3 }">
                                {{ item.name }}
                                <span style="color: #fff;padding-left: 30px;">${{ item.value }}</span>
                            </div>
                            <div style="color: #00f0ff">
                                {{ item.profit }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 合约账户 -->
                <div v-show="index == 2 || index == 3 || index == 4 || index == 5">
                    <div class="account">
                        <div style="font-size: 18px;">{{ source[index].name }}{{ $t('估值') }}</div>
                        <div style="padding-top: 10px;font-size: 22px;">
                            ${{ totalMoney }}
                            <span style="padding-left: 10px;">{{ unit }}</span>
                        </div>
                        <div class="btnS">
                            <div @click="$router.push('/mobile/topUp')">{{ $t('充值') }}</div>
                            <div @click="$router.push('/mobile/extract')">{{ $t('提币') }}</div>
                            <div @click="goToTab(7)">{{ $t('划转') }}</div>
                        </div>
                        <van-search v-model="searchValue" :placeholder="$t('搜索')" background="#000" @input="searchC" />
                        <van-checkbox v-model="checked" shape="square" icon-size="14px" @click="checkboxC"> {{ textS }}
                        </van-checkbox>
                        <div class="table">
                            <!-- 表头 -->
                            <van-row class="header">
                                <van-col span="6" class="vanItem">{{ $t('币种') }}</van-col>
                                <van-col span="5" class="vanItem">{{ $t('权益') }}</van-col>
                                <van-col span="4" class="vanItem">{{ $t('占比') }}</van-col>
                                <van-col span="5" class="vanItem">{{ $t('冻结') }}</van-col>
                                <van-col span="4" class="vanItem">{{ $t('操作') }}</van-col>
                            </van-row>
                            <!-- 数据 -->
                            <div class="scroll">
                                <van-row v-for="item in accountList" :key="item.id" class="row">
                                    <van-col span="6" class="rowItem">
                                        <van-image width="20" :src="item.image" />
                                        <div style="padding-left: 6px;">
                                            <div>{{ item.symbol }}</div>
                                            <div style="padding-top: 2px;">{{ item.title }}</div>
                                        </div>
                                    </van-col>
                                    <van-col span="5" class="trade">
                                        <div>{{ item.value }}</div>
                                        <div style="padding-top: 2px;">${{ item.usdt_value }}</div>
                                    </van-col>
                                    <van-col span="4" class="trade">
                                        {{ item.percent }}%
                                    </van-col>
                                    <van-col span="5" class="trade">
                                        {{ item.lock }}
                                    </van-col>
                                    <van-col span="4" class="trade">
                                        <div class="buySell" v-if="index != 4" @click="tradeS(item)">
                                            {{ $t('交易') }}
                                        </div>
                                        <div class="buySell" @click="goToTab(7)" v-if="index == 4">
                                            {{ $t('划转') }}
                                        </div>
                                    </van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 法币账户 -->
                <div v-show="index == 1">
                    <div class="account">
                        <div style="font-size: 18px;">{{ source[index].name }}</div>
                        <div style="padding-top: 10px;font-size: 22px;">
                            ${{ totalMoney }}
                            <span style="padding-left: 10px;">{{ unit }}</span>
                        </div>
                        <div class="btnF">
                            <!-- <div @click="$router.push('/mobile/quick')">我要买卖</div> -->
                            <div @click="goToTab(7)">{{ $t('划转') }}</div>
                        </div>
                        <div style="padding: 10px 0;font-size: 20px;">{{ $t('资产动态') }}</div>
                        <div class="table">
                            <!-- 数据 -->
                            <div class="scroll" style="  height: 54vh;">
                                <van-row v-for="item in fiatCurrency" :key="item.id" class="row">
                                    <van-col span="9" class="trade" style="text-align: left;">
                                        <div>{{ item.account }}</div>
                                        <div style="padding-top: 4px;color: #888;">{{ item.createtime_text }}</div>
                                    </van-col>
                                    <van-col span="9" class="trade">
                                        {{ item.type_text }}
                                    </van-col>
                                    <van-col span="6" class="trade" style="text-align: right"
                                        :style="{ color: item.money > 0 ? '#00f0ff' : '#ff4834' }">
                                        <div>{{ item.money }}</div>
                                        <div style="padding-top: 4px;">{{ item.coin_name }}</div>
                                    </van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                </div>
                <!--订单中心-->
                <div v-show="index == 6">
                    <orderS :dataList="dataList" :orderList="orderList" @orderData="orderData" :totalS="totalW"
                        :objectS="objectS" />
                </div>
                <div v-show="index == 7">
                    <convertS :toColumns="toColumns" :columnsT="columnsT" :usersList="usersList"
                        @transferList="transferList" @transferData="transferData" />
                </div>
            </van-tab>
        </van-tabs>
        <Footer></Footer>
    </div>
</template>
<script>
import { get } from '@/http/request'
import Footer from '@/common/mobile/Footer.vue'
import LineChart from "@/common/mobile/LineChart.vue";
import LineChart1 from "@/common/mobile/LineChart1.vue";
import convertS from "./common/convert.vue";
import orderS from "./common/order.vue";
import apis from '@/http/api'

export default {
    components: {
        Footer,
        LineChart,
        LineChart1,
        convertS,
        orderS
    },
    data() {
        return {
            textS: this.$t('隐藏金额 < 1USD的币种'),
            checked: false,
            searchValue: '',
            active: 0,
            indexS: 0,
            xData: [],
            yData: [],
            totalMoney: '',
            rowList: [
                {
                    name: this.$t('24小时'),
                    id: '1'
                },
                {
                    name: this.$t('7日'),
                    id: '2'
                },
                {
                    name: this.$t('30日'),
                    id: '3'
                },
                {
                    name: this.$t('365日'),
                    id: '4'
                }],
            source: [
                {
                    name: this.$t('资产总览')
                },
                {
                    name: this.$t('法币账户')
                },
                {
                    name: this.$t('现货账户')
                },
                {
                    name: this.$t('合约账户')
                },
                {
                    name: this.$t('期权账户')
                },
                {
                    name: this.$t('理财账户')
                },

                {
                    name: this.$t('订单中心')
                },
                {
                    name: this.$t('划转')
                }
            ],
            accountInfo: [],
            accountList: [],
            fiatCurrency: [],
            dataList: [],
            orderList: [],
            timer: null,
            totalW: '',
            unit: '',
            objectS: {},
            usersList: [],
            toColumns: [],
            columnsT: []

        };
    },
    mounted() {
        this.allMoney()
        this.typeList()
        this.orderData(1)
        this.totalEchart()
        this.transferData()
        this.transferList()
    },
    beforeUnmount() { },
    methods: {
        tradeS(item) {
            this.$router.push(`/mobile/trade?code=${item.symbol}`)
        },
        async allMoney() {
            const res = await get(apis.userAllMoney, { limit: 999 })
            if (res.code == 1) {
                this.totalMoney = res.data.total_money
                this.unit = res.data.unit
                // this.accountInfo = res.data.account_info.slice(1)
                this.accountInfo = res.data.account_info
                return
            }
        },
        async accountData() {
            const res = await get(apis.accountData, { account: this.active - 1, limit: 9999, hidden: this.checked ? 1 : 0, key: this.searchValue })
            if (res.code == 1) {
                this.totalMoney = res.data.total_money
                this.accountList = res.data.account_info
                this.unit = res.data.unit
                return
            }
        },
        //法币
        async legalData() {
            const res = await get(apis.getLegalData, { limit: 9999, })
            if (res.code == 1) {
                this.totalMoney = res.data.total_money
                this.fiatCurrency = res.data.wallet_log
                this.unit = res.data.unit
                return
            }
        },
        //订单中心
        async typeList() {
            const res = await get(apis.orderTypeList)
            if (res.code == 1) {
                this.dataList = res.data
                return
            }
        },
        async orderData(row) {
            const res = await get(apis.getOrderData, { limit: 9999, type: row })
            if (res.code == 1) {
                this.orderList = res.data.list
                this.totalW = res.data.total + ''
                if (row == 3) {
                    this.objectS.pecent = res.data.pecent//已还
                    this.objectS.borrow = res.data.borrow//已借金额 
                    this.objectS.repay = res.data.repay
                }

                return
            }
        },
        //资产走势
        async totalEchart() {
            const res = await get(apis.totalEchart, { time: this.indexS + 1 })
            if (res.code == 1) {
                this.xData = res.data.xData
                this.yData = res.data.yData
                return
            }
        },
        //划转 记录
        async transferList() {
            const res = await get(apis.transferList, { limit: 9999, showLoading: false })
            if (res.code == 1) {
                this.usersList = res.data.list
                return
            }
        },
        //划转 下拉框
        async transferData() {
            const res = await get(apis.transferData, { showLoading: false })
            if (res.code == 1) {
                console.log(res.data, 'res.data');
                this.columnsT = [res.data.coins]
                this.toColumns = res.data.wallet_list
                return
            }
        },

        onChange(name) {
            this.searchValue = ''
            this.checked = false
            if (name == 0) {
                this.allMoney()
            }
            if (name == 2 || name == 3 || name == 4 || name == 5) {
                this.accountData()
            }
            if (name == 1) {
                this.legalData()
            }

        },
        timeCk(index) {
            this.indexS = index
            this.totalEchart()
        },
        //划转
        goToTab(index) {
            this.active = index
        },
        //隐藏
        checkboxC() {
            this.accountData()
        },
        //搜索
        searchC() {
            clearTimeout(this.timer)   // 清除上一次定时器
            this.timer = setTimeout(() => {
                this.accountData()
            }, 800)
        }

    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 60px;
    padding-top: 50px;
    font-size: 14px;

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #1e1e2f;
        margin-top: 10px;
    }


    .account {
        border-radius: 20px;
        padding: 15px;
        margin-top: 15px;
        border: 1px solid #2b2b3d;

        ::v-deep .van-search__content {
            background-color: #000;
            border: 1px solid #323233;

        }

        ::v-deep .van-field__control {
            color: #fff;
        }

        ::v-deep .van-search {
            padding: 10px 0px;
        }

        ::v-deep .van-checkbox__label {
            font-size: 15px;
            color: #606266;
        }

        .btnS {
            display: flex;
            justify-content: space-between;
            padding-top: 10px;
            margin-bottom: 10px;

            div {
                width: 28%;
                border: 1px solid #fff;
                padding: 6px 0;
                border-radius: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .btnF {
            display: flex;
            justify-content: space-between;
            padding-top: 10px;
            margin-bottom: 10px;

            div {
                width: 48%;
                border: 1px solid #fff;
                padding: 6px 0;
                border-radius: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .table {
            background: #000;
            color: #fff;
            margin-top: 10px;
            font-size: 12px;

            .header {
                background: #1c222c;
                padding: 10px 0;
                border-radius: 5px;

                .vanItem {
                    text-align: center;
                }
            }

            .scroll {
                overflow-y: auto;
                height: 46vh;
                scrollbar-width: none;
                /* Firefox */
                -ms-overflow-style: none;
                /* IE/Edge */
            }

            .row {
                border-bottom: 1px solid #222b39;
                padding: 10px 0px;
                display: flex;
                align-items: center;
                font-size: 11px;

                .rowItem {
                    display: flex;
                    align-items: center;
                }

                .trade {
                    text-align: center;

                    .buySell {
                        border: 1px solid #fff;
                        padding: 2px 10px;
                        border-radius: 30px;
                        display: inline-block;
                    }
                }
            }
        }
    }

    .overview {
        border-radius: 20px;
        padding: 15px;
        padding-bottom: 0;
        margin-top: 15px;
        border: 1px solid #2b2b3d;

        .titleS {
            text-align: center;
            font-size: 26px;
            padding-top: 24px;
        }

        .column {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #1d1e26;
            padding: 24px 0;

            .color1 {
                color: #ef9363;

            }

            .color2 {
                color: #3ca4dd;

            }

            .color3 {
                color: #be74dd;

            }

            .color4 {
                color: #ff4834;
            }
            .color5 {
                color: #fff;
            }

            .dot1 {
                background: #ef9363;
            }

            .dot2 {
                background: #3ca4dd;
            }

            .dot3 {
                background: #be74dd;
            }

            .dot4 {
                background: #ff4834;
            }
            
            .dot5 {
                background: #fff;
            }

            .dot {
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 5px;
            }


        }

        .trend {
            padding-top: 20px;
            display: flex;
            align-items: center;

            .trendW {
                display: flex;
                padding-left: 30px;
                align-items: center;

                .switchS {
                    border: 1px solid #000;
                    padding: 2px 10px;
                    border-radius: 20px;
                    font-size: 12px;
                    color: #afafaf;
                }

                .switchB {
                    border: 1px solid #fff;
                    color: #fff;

                }
            }
        }

        .btn {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            padding-top: 10px;

            div {
                width: 40%;
                border: 1px solid #fff;
                padding: 10px 0;
                margin-bottom: 30px;
                border-radius: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }


}
</style>
